import { reverseToDateObject } from "./dateTransform";

export interface IDataAgendamento {
  weekday: string;
  date: string;
}

/**
 * Splits an ISO `diaAgendado` ("YYYY-MM-DD") into the weekday ("Segunda-feira")
 * and the long date ("06 de julho de 2026") in pt-BR. Returns `null` when the
 * agendamento has no (valid) day yet.
 */
export function getDataAgendamento(
  diaAgendado?: string | null,
): IDataAgendamento | null {
  const data = diaAgendado ? reverseToDateObject(diaAgendado) : undefined;

  if (!data || isNaN(data.getTime())) return null;

  const weekday = new Intl.DateTimeFormat("pt-BR", { weekday: "long" }).format(
    data,
  );
  const date = new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(data);

  return { weekday: weekday.charAt(0).toUpperCase() + weekday.slice(1), date };
}
